<!-- App Main Structure -->
<template>
    <div class="app-default-layout">
        <template v-if="loading">
            <!--<diamond></diamond>-->
            <!--<rotate-square2></rotate-square2>-->
            <circle2></circle2>
        </template>
        <template v-else>
            <!-- App Header -->
            <!--<app-header></app-header>-->
            <!-- App Main Content -->
            <!--class="Vuely-toolbar"-->
            <v-toolbar app
                       :color="activeHeaderFilter.class"
                       fixed>
                <!--<v-toolbar-side-icon></v-toolbar-side-icon>-->
                <v-toolbar-title>
                    <div class="mt-2">
                        <router-link to="/abbonati/ricerca">
                            <img :src="appLogo" class="img-responsive" width="60" />
                        </router-link>
                    </div>
                </v-toolbar-title>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <router-link to="/users" v-if="showNewUserLink">Utenti</router-link>
                &nbsp;&nbsp;&nbsp;&nbsp;<span v-if="showNewUserLink">-</span>&nbsp;&nbsp;&nbsp;&nbsp;
                <router-link to="/users/new-user" v-if="showNewUserLink">Crea nuovo utente</router-link>
                <v-spacer></v-spacer>
                {{signInName}}&nbsp;&nbsp;
                <router-link to="/users/change-password">Modifica password</router-link>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <v-btn icon @click="logout">
                    <v-icon dark>power_settings_new</v-icon>
                </v-btn>
            </v-toolbar>

            <v-content>
                <!-- App Router -->
                <transition name="router-anim" :enter-active-class="`animated ${selectedRouterAnimation}`">
                    <router-view></router-view>
                </transition>
            </v-content>
        </template>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    //import Header from "Components/Header/Header.vue";
    import Customizer from "Components/Customizer/Customizer";
    import AppConfig from "Constants/AppConfig";

    export default {
        data() {
            return {
                loading: true,
                appLogo: AppConfig.appLogo2,
                parsedJWT: {}
            };
        },
        components: {
            appCustomizer: Customizer,
        },
        computed: {
            ...mapGetters([
                "activeHeaderFilter",
                "selectedRouterAnimation"
            ]),
            showNewUserLink() {
                if (this.parsedJWT.role && this.parsedJWT.role === "Admin")
                    return true;

                return false;
            },
            signInName() {
                if (this.parsedJWT.SignInName)
                    return "Ciao, " + this.parsedJWT.SignInName;

                return "";
            }
        },
        mounted() {
            const parseJwt = (token) => {
                try {
                    return JSON.parse(atob(token.split('.')[1]));
                } catch (e) {
                    return null;
                }
            };

            this.parsedJWT = parseJwt(localStorage.getItem('token'));

            setTimeout(() => {
                this.loading = false;
            }, 2000);
        },
        methods: {
            logout() {
                var instance = this;

                localStorage.removeItem("token");

                instance.$router.push("/login");
            }
        }
    };
</script>
<style scoped>

    .app-default-layout {
        height: 100vh;
    }
</style>
